import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import Beret from './Beret'
import LoupsGarous from './LoupsGarous'
import LoveLetter from './LoveLetter'
import { vuexfireMutations } from 'vuexfire'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

export default new Vuex.Store({
    modules: {
        Beret,
        LoupsGarous,
        LoveLetter
    },
    mutations: {
        ...vuexfireMutations
    },
    plugins: [vuexLocal.plugin]
})
